import { render, staticRenderFns } from "./NFLGameStatistics.vue?vue&type=template&id=ecb06c2e&"
import script from "./NFLGameStatistics.vue?vue&type=script&lang=js&"
export * from "./NFLGameStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports